export default "__VITE_ASSET__DkGDltey__"